export default __webpack_public_path__ + "0fe317217b4d8ba58aa09019bc30ca34.png";